import { render, staticRenderFns } from "./jingyu.vue?vue&type=template&id=712e895a&scoped=true"
import script from "./jingyu.vue?vue&type=script&lang=js"
export * from "./jingyu.vue?vue&type=script&lang=js"
import style0 from "./jingyu.vue?vue&type=style&index=0&id=712e895a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712e895a",
  null
  
)

export default component.exports